import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Inputfiledsbase } from '../../../../inputfileds/models/inputfiledsbase';
import { Observable } from 'rxjs';
import { sectionView } from '../sections/sections.component';
import { environment } from '../../../../../environments/environment';
import { ApiservicesService } from '../../../../Services/Apis/apiservices.service';
import { SectionsService } from '../../../../inputfileds/form_services/academics/sections/sections.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { QuestionControlService } from '../../../../inputfileds/form_services/question-control.service';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { DynamicFormQuestionComponent } from '../../../../inputfileds/dynamic-form-question/dynamic-form-question.component';
import { SelectionModel } from '@angular/cdk/collections';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ToastComponent } from '../../../../components/toast/toast.component';
import { ToastService } from '../../../../Services/toast/toast.service';
import { TranslateDirective } from '../../../../components/Utilites/Directives/translate.directive';

export interface Student {
  index: number;
  Name: number;
  Dost_ID: string;
  Roll_No: string;
  Email_id: string;
  Department: string;
  Academic_Year: string;
  Action: any;
}

@Component({
    selector: 'app-academicregulationsview',
    templateUrl: './academicregulationsview.component.html',
    styleUrl: './academicregulationsview.component.scss',
    imports: [
        FormsModule,
        MatFormFieldModule,
        MatMenuModule,
        MatTableModule,
        MatIconModule,
        RouterModule,
        MatButtonModule,
        MatInputModule,
        ReactiveFormsModule,
        MatExpansionModule,
        DynamicFormQuestionComponent,
        CommonModule,
        MatTabsModule,
        MatDividerModule,
        MatDialogModule,
        MatCheckboxModule,
        TranslateDirective
        // ToastComponent
    ],
    providers: [QuestionControlService, ApiservicesService, SectionsService]
})
export class AcademicregulationsviewComponent {

  questions: Inputfiledsbase<string>[] | null = [];
  questions$: Observable<Inputfiledsbase<any>[]> | null | undefined;
  // createsection: Inputfiledsbase<any>[] | null = [];
  // createsection$: Observable<Inputfiledsbase<any>[]> | null | undefined;
  filtersectionForm!: FormGroup;
  // createsectionForm!: FormGroup;
  BatchData: any;
  datasend: any;
  sectionData: any;
  selected_semesterData: any;
  semestesubjectsData: any;
  dataSource = new MatTableDataSource<sectionView>();
  step = 0;
  onerror = 'https://dbraeiassetmanagement.blob.core.windows.net/dbraimt/prod/home/Placeholders/Placeholder_Image.jpg';
  editsubjectdata: any = null;
  isSubjectEnabled = false;
  assetUrl: string = environment.ASSET_URL;
  assetContainer: string = environment.ASSET_CONTAINER;
  displayedColumns: string[] = ['select', 'Roll_No', 'Name', 'Course_name', 'phone_number', 'email', 'Action'];
  studentdataSource = new MatTableDataSource<Student>();
  selection = new SelectionModel<Student>(true, []);
  total_count: any;
  paginationdata: any;
  fileName: string | null = null;
  selectedImageUrl: string | ArrayBuffer | null = null;
  file: File | null = null;
  filterdata: any[] | undefined;
  filters: any | undefined;
  selectedcourse_id : number| undefined;
  selectedregulation_id : number| undefined;

  @ViewChild('createSectionDialog') createSectionDialog!: TemplateRef<any>;
  addingsectionsdata: any | undefined;
  assigntostudenterrormessage: string = '';

  constructor(
    private router: Router,
    private apiservice: ApiservicesService,
    private dataService: SectionsService,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private qcs: QuestionControlService,
    private toastService: ToastService,
    // private dialogRef: MatDialogRef<createSectionDialog>
  ) {  }

  ngOnInit(): void {
    this.BatchData = history.state?.data;
    this.selectedcourse_id = this.BatchData?.course_id;
    this.selectedregulation_id = this.BatchData?.id;
    this.getSectionsDetails();
    // this.getstudentdetails();
  }

  getSectionsDetails(): void {
    const data = {
      "id": this.BatchData?.id,
      "code": this.BatchData?.code
    }
    this.apiservice.getBatchDetails(data).subscribe((res: any) => {
      this.sectionData = res;
      if(this.sectionData.code == 400){ 
        this.questions$ = this.dataService.getRegulationstudentfilterForm({ course_id: this.selectedcourse_id, academic_regulation_id: this.selectedregulation_id, sections: res.sections });
        this.questions$.subscribe(q => this.questions = q);
      }else{
        this.selectedcourse_id = res.course_id;
        this.selectedregulation_id = res.id;
        this.questions$ = this.dataService.getRegulationstudentfilterForm({ course_id: res.course_id, academic_regulation_id: res.id, sections: res.sections });
        this.questions$.subscribe(q => this.questions = q);
      }
      
      this.filtersectionForm = this.qcs.toFormGroup(this.questions as Inputfiledsbase<string>[]);
    })
  }

  getstudentdetails(semester_id?: number, section_id?: number, academic_year_id?: number) {
    this.filters = {
      semester_id: semester_id,
      section_id: section_id,
      academic_year_id: academic_year_id,
      academic_regulation_id: this.selectedregulation_id,
      course_id: this.selectedcourse_id
    }
    this.apiservice.getacademicstudent(this.paginationdata, this.filters).subscribe((res: any) => {
      this.studentdataSource = new MatTableDataSource<Student>(res?.rows);
      this.total_count = res.total_count;
    });
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.studentdataSource.data.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this.studentdataSource.data);
  }

  checkboxLabel(row?: Student): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.index + 1}`;
  }

  logSelection() {
    // if (this.selection.selected.length > 0) {
    //   this.openCreateSectionDialog();
    //   this.addingsectionsdata = this.sectionData.sections.filter((item: any) => item.id != this.filtersectionForm.value.section_id);
    //   this.createsection$ = this.dataService.getassigntoSectionForm({ sections: this.addingsectionsdata });
    //   this.createsection$.subscribe(questions => this.createsection = questions);
    //   this.createsectionForm = this.qcs.toFormGroup(this.createsection as Inputfiledsbase<string>[]);
    // } else {
    //   this.assigntostudenterrormessage = 'Please select the students'
    // }
  }

  pagination(event: any) {
    this.paginationdata = event;
    this.filterStudents();
  }

  filterStudents() {
    const formValues = this.filtersectionForm.value;
    this.getstudentdetails(formValues.semister_id, formValues.section_id, formValues.academic_year_id);
  }


  setStep(index: number, semester: any) {
    this.step = index;
    this.selected_semesterData = semester;
    // this.getsemestersubjectsDetails(semester)
  }

  openCreateSectionDialog(): void {
    const dialogRef = this.dialog.open(this.createSectionDialog, {
      width: '400px',
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  closeDialog(event: any) {
    this.dialog.closeAll();
    // const dialogRef = this.dialog.open(this.createSectionDialog);
    this.getSectionsDetails();
    document
      .getElementsByClassName('animate__animated')[0]
      .classList.remove('animate__fadeIn');
    document
      .getElementsByClassName('animate__animated')[0]
      .classList.add('animate__fadeOut');
    setTimeout(() => {
      this.dialog.closeAll();
    }, 1000);
  }

  onSaveClick(): void {
    this.dialog.closeAll();
  }

  backPage(): void {
    this.router.navigate(['/academicregulations']).then(() => {
      this.BatchData;
    });
  }

  onSubmit() {
    // const datastringfy =  JSON.stringify(this.createsectionForm.value.section_id);
    // const datapared = JSON.parse(datastringfy);
    this.datasend = {
      "students": this.selection.selected,
      // "section_name": this.createsectionForm.value.section_name
    };
    this.assignstudenttosection(this.datasend);
  }

  assignstudenttosection(event: any) {
    this.apiservice.AssignStudenttoSection(event).subscribe(
      (res: any) => {
        if (res.code === 200 && res.status === true) {
          this.toastService.showToast('success', 'Saved Successfully');
          this.closeDialog(true);
        } else if (res.status === false) {
          this.toastService.showToast('danger', res.message);
        }
      },
      (error) => {
        this.toastService.showToast('warning', `Error: ${error.message}`);
      }
    );
  }

  createAPi(event: any) {
    this.apiservice.createacadamics(event).subscribe(
      (res: any) => {
        if (res.code === 201 && res.status === true) {
          this.toastService.showToast('success', 'Saved Successfully');
          this.closeDialog(true);
        } else if (res.status === false) {
          this.toastService.showToast('danger', res.message);
        }
      },
      (error) => {
        this.toastService.showToast('warning', `Error: ${error.message}`);
      }
    );
  }
}
